import { Box, Typography } from "@material-ui/core"
import moment from "moment"

import useEventMetadata from "../../hooks/useEventMetadata"

import { useEventCardStyles } from "./styles"

type EventCardProps = {
  eventId: number | null
}

const EventCard = ({ eventId }: EventCardProps) => {
  const styles = useEventCardStyles()

  const {
    data: event,
    isLoading: isLoadingEvent,
  } = useEventMetadata(eventId)

  const isSkeletonActive = !eventId || isLoadingEvent

  if (isSkeletonActive) {
    return (
      <Box className={styles.container}>
        <Box className={styles.skeletonEventName} />

        <Box className={styles.skeletonDetails} />
      </Box>
    )
  }

  if (!event) {
    return (
      <Box className={styles.container}>
        <Typography className={styles.eventName}>
          Event not found
        </Typography>
      </Box>
    )
  }

  return (
    <Box className={styles.container}>
      <Typography className={styles.eventName}>
        {event.eventName}
      </Typography>

      <Box className={styles.detailsContainer}>
        <Typography className={styles.details}>
          {moment(event.eventStartDateTime.timeInMillis).format('MMMM DD, YYYY')}
        </Typography>

        {event.location && (
          <>
            <Box className={styles.detailsDivider} />

            <Typography className={styles.details}>
              {event.location.address.city}, {event.location.address.country}
            </Typography>
          </>
        )}
      </Box>
    </Box>
  )
}

export { EventCard }